module.exports = __webpack_public_path__ + "static/logo-wika-realty-e424ca11f620438f80ac2139c6dcfba0.png";